module.exports = __webpack_public_path__ + "static/media/icon2.dc9d9203.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/newpage/icon2.png
// module id = 216
// module chunks = 0